import React, { useEffect, useState, useRef } from "react";
import { Drawer, Button, Image,Col,Row,Popconfirm } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import "../Styles/NavBar.css";
import commonLib from "../control/commonLib";
import config from "../config.json";
import Services from "../network/Services";
import konsole from "../network/konsole";
import Modal from "antd/lib/modal/Modal";
import { AOLOGINBASEURL, EVENTCOUNTERURL } from "../network/url";
import AccountRoleChange from "./Account/AccountRoleChange";

const Navbar = ({ children, roleId ,setSubtinentDetails}) => {
  const [visible, setVisible] = useState(false);
  const [subtenantImage, setsubtenantImage] = useState("");
  const [subtenantId, setSubtenantId] = useState(null);
  const [roleIdValue, setRoleIdValue] = useState()
  const [open, setOpen] = useState(false);
  const userLoggedInDetail = commonLib.getObjFromStorage("userLoggedInDetail");
  const [showLogoutDropdown,setshowLogoutDropdown]=useState(false)
  const [showNotificationDropdown,setshowNotificationDropdown]=useState(false)
  const [showEmailDropdown,setshowEmailDropdown]=useState(false)
  const [pageTitle,setPageTitle] =useState("")
  const [isSwitchAccountOpen, setIsSwitchAccountOpen] = useState(false)
  const dropdownRef = useRef(null);

  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        if (!isSwitchAccountOpen) {
          setshowLogoutDropdown(false);
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isSwitchAccountOpen]);

  const handleClick = () => {
    setOpen(true);
  };

  useEffect(() => {
    const subtenantId = commonLib.getObjFromStorage("subtenantId");
    setSubtenantId(subtenantId);
    let valueRoleId = commonLib.getObjFromStorage("stateObj")?.roleId
    const rId=sessionStorage.getItem("roleUserId");
    Services.getAllUserRoleIdDetails().then((response) => {
      const allRoles = response.data?.data || [];
      const matched = allRoles?.find(item => String(item.value) === String(rId));
      setPageTitle(matched?.label || "");
    }).catch(() => {
      setPageTitle("");
    });

    setRoleIdValue(valueRoleId)
    Services.getSubtenantDetail(subtenantId, true)
      .then((res) => {
        setSubtinentDetails(res.data?.data[0])
        setsubtenantImage(res.data?.data[0]?.subtenantLogoUrl);
      })
      .catch((err) => {
        konsole.log("ErrorData", err);
      });
  }, []);


konsole.log("config.EVENTCOUNTERURL",EVENTCOUNTERURL)
  const backTOCoordinator = () =>{

    const stateObj = commonLib.getObjFromStorage('stateObj');
    konsole.log("stateObj", stateObj)
    const userId = stateObj?.userId
    konsole.log("aab",userId)
    let params = `appState=${stateObj.appState}&userId=${userId}&loggedUserId=${userId}&roleId=${stateObj.roleId}&loggenInId=${stateObj.loggenInId}`;
    window.location.replace(`${EVENTCOUNTERURL}?token=` + window.btoa(params));
    konsole.log("params",stateObj.appState,stateObj, params)

  }
  const handelconfrimation = () => {
    setOpen(false);
    const stateObj = commonLib.getObjFromStorage("stateObj");
    let params = `appState=${stateObj.appState}&userId=${
      stateObj.userId
    }&roleId=${stateObj.roleId}&loggenInId=${
      stateObj.loggenInId
      }&success=${true}`;
    sessionStorage.clear()
    window.location.replace( `${AOLOGINBASEURL}/Account/Signout?` + params);
  };

  return (
    <>
   <div className="header d-flex justify-content-between h-100 align-items-center w-100 border-1 border-bottom " style={{ position: "sticky", top: "0px", zIndex: "99",backgroundColor:"#2b2b2e" }} >
        {/* <div className="d-block d-lg-none">
          <Button className="menu" type="primary" icon={<MenuOutlined />} onClick={() => setVisible(true)} />
        </div> */}
        <div class="">
          {(subtenantId === 742 || subtenantId === 2)
            ? <img src='/icons/subtinentimg.svg' style={{ width: "190px", height: "3.5rem", objectFit: "contain", }} />
            : subtenantId === 3
              ? <img src='/icons/agingoptionlogo.svg' style={{ width: "250px", height: "3.5rem", objectFit: "contain", }} />
              : <img src={subtenantImage} style={{ width: "123px" ,height:"3.5rem", objectFit: "contain",}} />
          }
        </div>
        <div class="">
           <p className="pageTitleForAdm">{pageTitle}</p>
        </div>

        <div className="d-flex align-items-center">

          {roleId == 6 &&
            <span onClick={backTOCoordinator} >
              <img style={{ width: "30px", cursor: "pointer" }} className="me-1" src="./images/backButton.svg" alt="Error" />
            </span>
          }
          <p className="text d-none d-md-block d-lg-block m-0 cursor-pointer" style={{ fontSize: "15px" }}>
            <div
              ref={dropdownRef}
            >
              <div style={{display:'flex',justifyContent:"center",alignItems:'center',fontSize:"medium",color: "white"}} onClick={()=>  setshowLogoutDropdown(!showLogoutDropdown)}>
                <i class="fa fa-user-circle-o userICon" aria-hidden="true"></i>
                {userLoggedInDetail?.memberName}
                <img
                  className="notficationDown"
                  style={{ cursor: "pointer" }}
                  // src="/icons/down.png"
                  src="/icons/keyboard_arrow_up.svg"

                />
              </div>

              {showLogoutDropdown && <div class="dropdown_hoverDesign">
                <div class="dropdown-item" onClick={(e) => { e.stopPropagation(); setIsSwitchAccountOpen(true); setshowLogoutDropdown(false); }}>
                  <span class="icon">👤</span>
                  <span>Switch Account</span>
                </div>
                <div class="dropdown-item" onClick={(e) => { e.stopPropagation(); setOpen(true); setshowLogoutDropdown(false); }}>
                    <span class="icon">🔑</span>
                    <span>Log Out</span>
                  </div>
              </div>
              }
            </div>
          </p>



          {/* <Image className='admin' src='/images/spouse1.png' width={50}/> */}
          {/* <div onClick={handleClick} style={{ display: 'flex' }}>
            <p className="ms-4 text   m-0 " style={{ cursor: "pointer" }} >Logout</p>
            <img
              className="admin ms-0 mt-1"
              style={{ cursor: "pointer" }}
              src="/icons/logoutcircle.svg"
              width={18}
            />
          </div> */}

        </div>


        <AccountRoleChange
          isOpen={isSwitchAccountOpen}
          onClose={() => setIsSwitchAccountOpen(false)}
        />

        <Drawer
          title="Menu"
          placement="left"
          onClick={() => setVisible(false)}
          onClose={() => setVisible(false)}
          visible={visible}
        >
          {children}
        </Drawer>
      </div>

      <Modal
        className="logout-modal"
        visible={open}
        onOk={() => handelconfrimation()}
        onCancel={() => setOpen(false)}
        okText="YES"
        cancelText="NO"
        closable={false}
        maskClosable={false}
        centered
        zIndex={9999}
        width={500}
        bodyStyle={{ padding: '0px' }}
        okButtonProps={{
          style: {
            backgroundColor: '#720c20',
            color: 'white',
            border: 'none',
            height: '44px',
            minWidth: '90px',
            fontWeight: '600',
            borderRadius: '2px',
            marginTop:"7px",
            marginBottom:"17px"
          }
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: 'white',
            color: '#720c20',
            border: '1px solid #720c20',
            height: '44px',
            minWidth: '90px',
            fontWeight: '600',
            borderRadius: '2px',
            marginTop:"7px",
            marginBottom:"17px"
          }
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '14px 16px 12px 16px', borderBottom: '1px solid #bfbfbf' }}>
          <p style={{ fontSize: '16px', fontWeight: '700', color:'#474747', margin: 0 }}>Logout</p>
          <span onClick={() => setOpen(false)} style={{ cursor: 'pointer', fontSize: '25px', color: '#474747', lineHeight: 1, padding: '2px 6px' }}>×</span>
        </div>
        <p style={{ textAlign: 'center', fontSize: '16px', margin: '23px 20px 5px 20px' }}>Are you sure you want to LOGOUT ?</p>
      </Modal>
      <style>{`
        .logout-modal .ant-modal-footer { border-top: none; display: flex; justify-content: center; gap: 12px; }
        .logout-modal .ant-modal-close .ant-modal-close-x { color: white !important; }
        .logout-modal .ant-modal-close { color: white !important; }
        .logout-modal .ant-modal-close:hover { color: #ccc !important; }
      `}</style>
    </>

  );
};

export default Navbar;
